import config from '../../../configuration/configuration.js';
import AxiosRequest from '../../../utils/AxiosRequest.js';

export const GetClustersNamesRequest = (activationDate) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}ReportsKpis/GetAcceptanceReportsClusters`,
	params: { activationDate },
});

export const GetReportLastUpdateRequest = (reportType, activationDate, clusterName) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}ReportsKpis/GetAcceptanceReportsLastUpdate`,
	params: { reportType, activationDate, clusterName },
});

export const UpdateAcceptanceReportsRequest = (userId, reportType, activationDate, clusterName) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}ReportsKpis/UpdateAcceptanceReports`,
	params: { userId, reportType, activationDate, clusterName },
});

export const GetAcceptanceReportsActivationDatesRequest = () => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}ReportsKpis/GetAcceptanceReportsActivationDates`,
});

export const GenerateReportRequest = (userId, clusterName, preStartDate, preEndDate, postStartDate, postEndDate) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}ReportsKpis/GenerateReportAcceptance`,
	params: { userId, clusterName, preStartDate, preEndDate, postStartDate, postEndDate },
	hasLoading: false
});

